import { IconX } from "@tabler/icons-react";
import { SubmitHandler, useForm } from "react-hook-form";
import TextareaField from "../../../components/common/TextareaField";
import toast from "react-hot-toast";
import { useOrderReverseMutation } from "../../../apis/orderApis";
import { useLanguage } from "../../../context/LanguageContext";

// Define the expected form data type
interface ReverseOrderFormData {
  awbNumber: string;
}

export default function ReverseOrderModal({
  onClose,
  fetchData,
}: {
  onClose: () => void;
  fetchData?: () => void;
}) {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<ReverseOrderFormData>({
    defaultValues: {
      awbNumber: "",
    },
  });

  const { mutate: reverseOrderMutate, isPending: isReverseOrderPending } = useOrderReverseMutation();
  const { t } = useLanguage();

  const onSubmit: SubmitHandler<ReverseOrderFormData> = async (data: any) => {
    const awbArray = data.awbNumber
      .split("\n")
      .map((v: any) => v.trim())
      .filter((v: any) => v.length > 0);

    reverseOrderMutate(
      { orderId: awbArray },
      {
        onSuccess: (data: any) => {
          onClose();
          toast.success('Reverse Created Successfully')
          fetchData?.()
        },
        onError: (error: any) => {
          console.log(error, "error");
          toast.error(`${error}`);
        },
      }
    );

  };

  return (
    <div className="fixed inset-0 w-full h-screen bg-black/60 z-50 flex items-center justify-center font-sans">
      <form
        className="rounded-2xl"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex items-center">
          <div className=" bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] flex items-center justify-between px-6 py-4 w-full rounded-tl-3xl rounded-tr-[63px] ">
            <h2 className="text-2xl font-semibold text-[#212121]">
              {t("Create Reverse Order")}
            </h2>
          </div>
          <div className="relative ">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={38}
              height={37}
              viewBox="0 0 38 37"
              fill="none"
              className="absolute -bottom-[10px] -left-[8px] rotate-[-1.8deg]"
            >
              <path
                d="M0.5 0L4.86189 10.5496C10.4737 24.1222 22.9306 33.645 37.5 35.5L4.91509 37L0.5 0Z"
                fill="#F7F6F2"
              />
            </svg>

            <button
              type="button" // Use type="button" to prevent form submission
              onClick={onClose}
              className="bg-[#F2F2F7] rounded-full p-1 cursor-pointer w-12 h-12 ml-5 flex items-center justify-center flex-shrink-0 hover:bg-gray-300 transition"
            >
              {/* Using inline SVG component */}
              <IconX size={20} />
            </button>
          </div>
        </div>

        <div className="w-full py-6 px-8 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-tr-[30px]">
          <div className="w-[655px] space-y-4">
            {/* 4. Pass register and validation rules to TextareaField */}
            <TextareaField
              name="awbNumber"
              rows={8} // Increased rows for better input area
              label={t("Enter AWB Numbers (one per line)")}
              placeholder={t("Enter AWB Number 1") + "\n" + t("Enter AWB Number 2") + "\n..."}
              register={register}
              validation={{
                required: "AWB number(s) are required.",
                pattern: {
                  // Simple pattern to allow letters, numbers, and newlines
                  value: /^[a-zA-Z0-9\s]+$/,
                  message: "Only alphanumeric characters and new lines are allowed."
                }
              }}
              error={errors.awbNumber}
            />
          </div>
        </div>

        <div className="border-t border-[#D8D8D8] px-6 py-4 flex justify-end space-x-2 bg-gradient-to-tr from-[#FDF8E5] to-[#FAF8EC] rounded-b-[30px]">
          <button
            type="submit"
            disabled={isReverseOrderPending}
            className="bg-[#FBD037] hover:bg-yellow-400 text-[#000000] flex items-center rounded-full p-2 px-6 space-x-1 disabled:cursor-not-allowed cursor-pointer text-sm font-medium transition"
          >
            {isReverseOrderPending ? t("Submitting...") : t("Submit")}
          </button>
        </div>
      </form>
    </div>
  );
}